import { Section } from '../components/Section';
import { PANELISTS } from '../data/panelists';

export function ChatTeaser(): JSX.Element {
  return (
    <Section
      id="chat-teaser"
      label="LIVE WARM-UP"
      title={<>Argue with a bot. Now. Right now.</>}
      kicker="Both AI panelists are open for pre-debate sparring. Type a question, get a real reply. They will not be polite."
      background="bg"
      style={{ background: 'rgb(var(--color-ink))' }}
    >
      <div className="grid grid-cols-2 gap-6">
        {PANELISTS.filter((p) => p.type === 'ai').map((p) => (
          <button
            key={p.id}
            type="button"
            className="flex items-center gap-[18px] rounded-[14px] border-2 border-duck bg-bg p-6 text-left"
          >
            <div
              className="flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-full font-display text-3xl font-extrabold text-white"
              style={{ background: p.color }}
            >
              {p.initials}
            </div>
            <div className="flex-1">
              <div className="font-display text-[22px] font-extrabold text-ink">{p.name}</div>
              <div className="mt-0.5 text-sm text-ink-soft">{p.title}</div>
              <div className="mt-3 rounded-lg border border-[rgb(var(--color-ink)/12%)] bg-paper px-3 py-2 font-mono text-xs text-ink">
                <span className="text-beak">›</span> {p.promptStarters?.[0]}
              </div>
              <div className="mt-3 font-display text-sm font-bold text-beak">Open chat →</div>
            </div>
          </button>
        ))}
      </div>
    </Section>
  );
}
